import * as Sentry from "@sentry/react";
import { toast } from "sonner";
import { MutationError } from "@/lib/error-utils";

const PRODUCTION_HOSTS = new Set(["hub.livemotion.ch"]);

/** `production` on the real Hub, `preview` on every other deployed build. */
export function sentryEnvironment(hostname: string): string {
  return PRODUCTION_HOSTS.has(hostname) ? "production" : "preview";
}

/** Drops mutation failures that are not bugs (offline, permission refused). */
export function isExpectedFailure(error: unknown): boolean {
  return error instanceof MutationError && error.expected;
}

/**
 * Starts Sentry for built apps only. Vite dev servers (dev-env worktrees)
 * report nothing, since hot reloads throw errors that never reach users.
 */
export function initSentry() {
  // A mutation whose caller forgot to catch still tells the user what failed.
  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason instanceof MutationError) {
      toast.error(event.reason.message);
    }
  });

  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn: "https://8db92733ed9180c830518471bd6e3e33@o4511422674567168.ingest.de.sentry.io/4511422704648272",
    environment: sentryEnvironment(window.location.hostname),
    beforeSend(event, hint) {
      return isExpectedFailure(hint.originalException) ? null : event;
    },
  });
}
